import { assign, dispatch } from 'sdi/shape';
import { IUser } from 'sdi/source';
import {
    Duration,
    Layout,
    navigateMap,
    navigateMapAndTable,
    navigateTable,
} from './route';
import { fromNullable } from 'fp-ts/lib/Option';
import { QaMessageKey } from '../locale';
import { getLastSelectedId } from '../queries/qa';
import { Pair, scopeOption } from 'sdi/lib';
import { register } from '../components/modal';
import { renderTagsEditor } from '../components/modal/tag-editor';
import { getAutoZoom, getTheme } from '../queries/app';
import { updateCollection } from 'sdi/util';

export const setLayout = (l: Layout) => assign('app/layout', l);

export const setTheme = (t: string) => assign('app/theme', t);

export const setUserData = (u: IUser) => assign('data/user', u);

export const toggleRenderMapAndTable = () =>
    scopeOption()
        .let('theme', getTheme())
        .let('id', getLastSelectedId())
        .foldL(
            () => navigateMapAndTable(''), //TODO cannot go with no theme
            ({ theme, id }) => navigateMapAndTable(theme, id)
        );

export const toggleRenderTable = () =>
    scopeOption()
        .let('theme', getTheme())
        .let('id', getLastSelectedId())
        .foldL(
            () => navigateTable(''),
            ({ theme, id }) => navigateTable(theme, id)
        );

export const toggleRenderMap = () =>
    scopeOption()
        .let('theme', getTheme())
        .let('id', getLastSelectedId())
        .foldL(
            () => navigateMap(''),
            ({ theme, id }) => navigateMap(theme, id)
        );

export const setCollapsible = (name: string, render: boolean) =>
    dispatch('app/collapsible', s => updateCollection(s, name, render));

export const setRenderGlobalInfo = (v: boolean) =>
    setCollapsible('global-info', v);

export const clearRenderIssues = () =>
    dispatch('app/collapsible', s => {
        Object.keys(s)
            .filter(k => k.startsWith('issue-'))
            .forEach(k => (s[k] = false));
        return s;
    });

export const deselectRenderIssue = (id: number) =>
    setCollapsible(`issue-${id}`, false);

export const selectRenderIssue = (id: number) =>
    setCollapsible(`issue-${id}`, true);

export const setGlobalInfoDuration = (duration: Duration) =>
    assign('app/global/info/duration', duration);

// export const setNoteEditStatus =
//     (status: boolean) => assign('app/note/edit', status);

// export const toggleRenderLegend = () => setRenderLegend(!getRenderLsegend());
// export const setContactEditStatus =
//     (status: boolean) => assign('app/contact/edit', status);

export const messageKeyFromNullable = (message: QaMessageKey | null) =>
    fromNullable(message).getOrElse('null');

export const setAutoZoom = (autoZoom: boolean) =>
    assign('app/issue/zoom/auto', autoZoom);
export const changeAutoZoom = () =>
    getAutoZoom() ? setAutoZoom(false) : setAutoZoom(true);

export const setAutoCenter = (autoCenter: boolean) =>
    assign('app/issue/center/auto', autoCenter);

export const setLinkChangeId = (linkGroupId: number) =>
    assign('app/linked/change/id', linkGroupId);
export const clearLinkChangeId = () => assign('app/linked/change/id', null);

export const clearTextForm = () => assign('qa/notes/form', null);
export const setTextForm = (text: string) =>
    text === '' ? assign('qa/notes/form', null) : assign('qa/notes/form', text);

export const setEditStatus = (status: Pair<string, boolean>) =>
    assign('app/text/edit', status);
export const clearEditStatus = () => assign('app/text/edit', null);
export const setNewTextEdit = (editable: boolean) =>
    assign('app/source/new/edit', editable);

export const [closeTagsEditor, openTagsEditor] = register(
    'qa-tag-editor',
    renderTagsEditor
);
